module.exports = __webpack_public_path__ + "DBpediaLogo.png?cbd5ea32474f688069a7bf5ec1cc8366";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/DBpediaLogo.png
// module id = 1142
// module chunks = 0